import { render, staticRenderFns } from "./TriggerList.vue?vue&type=template&id=1389045a&scoped=true"
import script from "./TriggerList.vue?vue&type=script&lang=js"
export * from "./TriggerList.vue?vue&type=script&lang=js"
import style0 from "./TriggerList.vue?vue&type=style&index=0&id=1389045a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1389045a",
  null
  
)

export default component.exports